import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const ReporteGeneralHistorico = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.post(`/existencias/historico/general`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    reporteGeneralHistoricoMutation: mutation.mutate,
  };
}

export const ReporteSegundoHistorico = () => {
  const api = useApi();

  const mutate = async (params) => {
    console.log(params)
    const data = await api.post(`/existencias/historico/segundo-nivel`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    reporteSegundoHistoricoMutation: mutation.mutate,
  };
}

export const ReporteTerceroHistorico = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.post(`/existencias/historico/tercer-nivel`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    reporteTerceroHistoricoMutation: mutation.mutate,
  };
}

export const DownloadExcel = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.post(`/existencias/exportar`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
      responseType: 'blob', // Indicamos que esperamos un archivo binario (blob)
    });
    return data;
  };

  const mutation = useMutation(mutate);

  return {
    getDownloadExcel: mutation.mutate,
  };
}